@let componentVal = component();
@let visVal = visualization();
@let metricVal = metric();

<reports-visualization-layout>
  <div slot="header">
    <reports-visualization-title [name]="componentVal?.name ?? ''" />

    <div class="component-filters">
      <ng-content />
    </div>
  </div>
  <reports-visualization-loading-indicator
    [small]="false"
    [loading]="loading()"
    [loaded]="loaded()"
    [failed]="failed()"
    [resetKey]="$safeNavigationMigration(metricVal?.metric)"
  />

  @if (visVal && metricVal && componentVal) {
    <reports-visualization-renderer
      slot="renderer"
      [resourcesPreviewAvailable]="false"
      [rtResizeObserver]="{ initial: false }"
      [loading]="loading()"
      [loaded]="loaded()"
      [failed]="failed()"
      [data]="visVal"
      [component]="componentVal"
      [metric]="metricVal"
      [currColWidth]="currColWidth()"
      [allowRefreshing]="true"
      (refresh)="refresh.emit()"
      (tableSortChange)="tableSortChange.emit($event)"
    />
  }
</reports-visualization-layout>
